import {
	AddonProvider,
	AxiosConfig,
	BlockProvider,
	CurrencyTypeProvider,
	FCC,
	InjectBrandFavicons,
	PortalStackProvider,
	ToastList,
	ToastProvider,
} from "@dgs/core";
import { JarvisAuthProvider } from "./auth";
import { useFrontendConfig } from "./config/useFrontendConfig";
import { HtmlTitle } from "./htmlTitle";
import { JarvisLocaleProvider } from "./JarvisLocaleProvider";
import { JarvisThemeProvider } from "./JarvisThemeProvider";

export const AppProviders: FCC = ({ children }) => {
	const { apiUrl, brand, addons } = useFrontendConfig();
	return (
		<JarvisAuthProvider>
			<JarvisLocaleProvider>
				<CurrencyTypeProvider>
					<ToastProvider>
						<AddonProvider addons={addons}>
							<AxiosConfig apiUrl={apiUrl} />
							<JarvisThemeProvider>
								<PortalStackProvider>
									<InjectBrandFavicons brand={brand} />
									<ToastList />
									<HtmlTitle />
									<BlockProvider>{children}</BlockProvider>
								</PortalStackProvider>
							</JarvisThemeProvider>
						</AddonProvider>
					</ToastProvider>
				</CurrencyTypeProvider>
			</JarvisLocaleProvider>
		</JarvisAuthProvider>
	);
};
